import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import AcaoButtons from "../../Shared/AcaoButtons";

// Etapa "Análise RH" — Aprovar/Reprovar, com justificativa da análise obrigatória para ambas as ações.
export default function EtapaPromocaoAnalise({ acoes = [], acaoEmExecucao, onExecutarAcao, justificativa }) {
    const [justificativaAnalise, setJustificativaAnalise] = useState(justificativa || "");

    function executar(acao) {
        if (!justificativaAnalise.trim()) return;
        onExecutarAcao(acao, { dados: { justificativaAnalise } });
    }

    return (
        <div className="flex flex-col gap-4">
            <Textarea
                label="Justificativa da análise"
                required
                value={justificativaAnalise}
                onChange={e => setJustificativaAnalise(e.target.value)}
                rows={3}
            />
            <AcaoButtons
                acoes={acoes}
                acaoEmExecucao={acaoEmExecucao}
                onAcao={executar}
                disabled={!justificativaAnalise.trim()}
            />
        </div>
    );
}
